import React from "react";
import { Flex, Text } from "@chakra-ui/react";
import AppButton from "@/features/line-sheet-sets/app-button";
import CustomIcon from "../../../../../../../public/icons-v1_1";
import useI18nHelper from "@/features/ui/hooks/use-i18n-helper";
import { MEMBERSHIP_COLORS } from "@/features/pathpick/features/membership/constants";

interface Props {
  onStart: () => void;
}

// 무료체험 유도 배너 — 결제 전(NONE)이고 체험을 아직 안 쓴 바이어에게만 노출.
// 실제 신청 플로우(조건 확인 모달 → FREE 플랜 신청)는 페이지가 들고 있다.
function PathPickMembershipFreeTrialBanner({ onStart }: Props) {
  const { t } = useI18nHelper();

  return (
    // CTA가 ~186px를 비축소로 먹고 아이콘 40px까지 더하면 375px에서 제목·설명이
    // 들어갈 자리가 ~89px뿐이다. 모바일에서는 CTA를 아래로 내린다.
    <Flex
      justifyContent={"space-between"}
      flexDirection={{ base: "column", md: "row" }}
      alignItems={{ base: "flex-start", md: "center" }}
      gap={"16px"}
      padding={"18px 20px"}
      borderRadius={"14px"}
      border={`1px solid ${MEMBERSHIP_COLORS.blueBorder}`}
      background={MEMBERSHIP_COLORS.blueBg}
    >
      <Flex gap={"12px"} alignItems={"center"} minWidth={0}>
        <Flex
          boxSize={"40px"}
          alignItems={"center"}
          justifyContent={"center"}
          borderRadius={"8px"}
          background={MEMBERSHIP_COLORS.blue}
          flexShrink={0}
        >
          <CustomIcon src={"star"} width={20} height={20} color={"#FFFFFF"} />
        </Flex>
        <Flex flexDirection={"column"} gap={"2px"} minWidth={0}>
          <Text
            textStyle={"body-md-bold"}
            fontSize={"16px"}
            color={MEMBERSHIP_COLORS.textStrong}
          >
            {t("membership:free_trial_banner.title")}
          </Text>
          <Text
            textStyle={"body-sm-regular"}
            color={MEMBERSHIP_COLORS.textMuted}
          >
            {t("membership:free_trial_banner.description")}
          </Text>
        </Flex>
      </Flex>
      <AppButton
        variant={"primary"}
        onClick={onStart}
        chakraProps={{
          flexShrink: 0,
          height: "40px",
          borderRadius: "10px",
          background: MEMBERSHIP_COLORS.blue,
          padding: "0 18px",
        }}
      >
        <Text textStyle={"body-sm-bold"} fontWeight={800} color={"#FFFFFF"}>
          {t("membership:free_trial_banner.cta")}
        </Text>
      </AppButton>
    </Flex>
  );
}

export default PathPickMembershipFreeTrialBanner;
